import {Card, Flex, Text} from '@sanity/ui'

// eslint-disable-next-line no-restricted-imports
import {SanityScribble} from '@/ui/app/SanityLogo'

import {UserAvatar} from '../../../generic/user-avatar'
import {useRelativeTime} from '../../../hooks'

interface InvitedByCellProps {
  createdAt: string
  displayName?: string
  imageUrl?: string
  isServiceInvite: boolean
}

export function InvitedByCell(props: InvitedByCellProps) {
  const {createdAt, displayName, isServiceInvite, imageUrl} = props

  const timeAgo = useRelativeTime(createdAt, {
    minimal: true,
  })

  return (
    <Flex align="center" gap={2}>
      {!isServiceInvite && <UserAvatar displayName={displayName || ''} src={imageUrl || ''} />}

      {isServiceInvite && (
        <Flex align="center" justify="center" style={{width: 25, height: 25}} sizing="border">
          <Card style={{width: 20, height: 20}} title="Sanity">
            <SanityScribble />
          </Card>
        </Flex>
      )}

      <Flex flex={1} direction={'column'} gap={2}>
        {isServiceInvite || displayName ? (
          <Text size={1} title={createdAt} textOverflow="ellipsis">
            {isServiceInvite ? 'System' : displayName}
          </Text>
        ) : (
          <Text size={1} textOverflow="ellipsis" muted>
            Unknown user
          </Text>
        )}
        <Text size={0} muted textOverflow="ellipsis">
          {timeAgo}
        </Text>
      </Flex>
    </Flex>
  )
}
